var map = {
	"./borrar.png": "aeda",
	"./editar.png": "c135",
	"./flecha-arriba (1).png": "ea27",
	"./flecha-hacia-abajo (1).png": "9dc3",
	"./mas.png": "3734",
	"./mover-abajo.png": "f70d",
	"./mover-arriba.png": "0fe0",
	"./salvar.png": "048c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e20";